var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "check-circle_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v36H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#check-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.275 20.7l-3.262-3.262a1.335 1.335 0 00-1.031-.393 1.464 1.464 0 00-1.032.43c-.275.275-.412.625-.412 1.05 0 .425.137.775.412 1.05l4.275 4.275c.275.275.625.412 1.05.412.425 0 .775-.137 1.05-.412l8.512-8.513c.276-.274.407-.618.395-1.031a1.468 1.468 0 00-.432-1.031c-.275-.275-.625-.412-1.05-.412-.425 0-.775.137-1.05.412L16.275 20.7zm2.1 12.3c-2.075 0-4.025-.394-5.85-1.182-1.825-.787-3.412-1.856-4.763-3.206-1.35-1.35-2.418-2.937-3.205-4.762-.788-1.825-1.182-3.775-1.182-5.85 0-2.075.394-4.025 1.182-5.85.787-1.825 1.855-3.412 3.205-4.763 1.35-1.35 2.938-2.418 4.763-3.206C14.35 3.393 16.3 3 18.375 3c2.075 0 4.025.393 5.85 1.18 1.825.788 3.412 1.857 4.762 3.208 1.35 1.35 2.419 2.937 3.206 4.762.788 1.825 1.182 3.775 1.182 5.85 0 2.075-.394 4.025-1.182 5.85-.787 1.825-1.855 3.412-3.205 4.762-1.35 1.35-2.938 2.419-4.763 3.206C22.4 32.606 20.45 33 18.375 33zm0-3c3.325 0 6.157-1.169 8.494-3.506 2.337-2.337 3.506-5.169 3.506-8.494s-1.169-6.156-3.506-8.495C24.532 7.168 21.7 6 18.375 6s-6.156 1.168-8.493 3.505C7.544 11.843 6.375 14.675 6.375 18c0 3.325 1.169 6.157 3.507 8.494C12.219 28.831 15.05 30 18.375 30z"
  }))));
}
export default SvgCheckCircle;